import {isAwinTest} from "../../app/read_rp_environment_variables";
import {Currency} from "../../types/Currency";
import {getCurrencyISOCode} from "../../utils/get_currency";

declare global {
    interface Window {
        AWIN?: {
            Tracking?: {
                Sale?: {
                    amount?: string;
                    channel?: string;
                    orderRef?: string;
                    parts?: string;
                    currency?: string;
                    voucher?: string | null;
                    test?: string;
                };
                run: () => void;
            };
        };
    }
}

interface IAwinParams {
    applicationId: string;
    currency?: Currency;
}

export const awinHit = (params: IAwinParams) => {
    const canTriggerConversion = checkAwinCookie();
    const AWIN = window.AWIN;

    if (canTriggerConversion && typeof AWIN != "undefined" && typeof AWIN.Tracking != "undefined") {
        AWIN.Tracking.Sale = {};
        AWIN.Tracking.Sale.amount = "1";
        AWIN.Tracking.Sale.channel = "aw";
        AWIN.Tracking.Sale.orderRef = params.applicationId;
        AWIN.Tracking.Sale.parts = "DEFAULT:1";
        AWIN.Tracking.Sale.currency = getCurrencyISOCode(params.currency || Currency.PLN);
        AWIN.Tracking.Sale.test = isAwinTest ? "1" : "0";
        AWIN.Tracking.run();
    }
};

const checkAwinCookie = () => {
    const awinCookie = document.cookie?.split(";")?.filter((cookie) => cookie.includes("_aw_") && cookie.split("=")[1][0] !== "{")[0];

    if (awinCookie) {
        return true;
    }

    const ourAwinCookie = document.cookie?.split(";")?.find((cookie) => cookie.includes("awin") && cookie.includes("userSession"));

    if (ourAwinCookie) {
        const parsedCookie = JSON.parse(ourAwinCookie.split("=")[1]);
        // if awin cookie dosent exist we need to rectiate it or conversion will not start
        document.cookie = `${parsedCookie.name}=${parsedCookie.value}; path=/}`;
        return true;
    }

    return false;
};
